import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import waarnemersModule from '@/store/modules/waarnemers.module';
import telescopenModule from '@/store/modules/telescopen.module'
import waarnemingenModule from "@/store/modules/waarnemingen.module";
import methodenModule from "@/store/modules/methoden.module";
import rollenModule from "@/store/modules/rollen.module";
import telescoopmodellenModule from "@/store/modules/telescoopmodellen.module";
import parametersModule from "@/store/modules/parameters.module";
import authModule from "@/store/modules/auth.module";
import rapportenModule from "@/store/modules/rapporten.module";
import vasteDataModule from "@/store/modules/vasteData.module";
import coordinatenModule from "@/store/modules/coordinaten.module"
import develloperModule from "@/store/modules/develloper.module";

Vue.use(Vuex)

const store = new Vuex.Store(
    {
        plugins: [
            createPersistedState({
                storage: window.sessionStorage,
            })
        ],
        modules: {
            authModule: authModule,
            waarnemersModule: waarnemersModule,
            telescopenModule: telescopenModule,
            waarnemingenModule: waarnemingenModule,
            methodenModule: methodenModule,
            rollenModule: rollenModule,
            telescoopmodellenModule: telescoopmodellenModule,
            parametersModule: parametersModule,
            rapportenModule: rapportenModule,
            vasteDataModule:vasteDataModule,
            coordinatenModule: coordinatenModule,
            develloperModule: develloperModule,
        },
        state() {
            return {}
        },
        getters: {},
        mutations: {},
        actions: {}
    })
export default store

function setupAccessTokenWatcher(store) {
    store.watch(
        (state) => state.authModule.accessToken,
        (token) => {
            if (!token) return
            // Decode JWT payload
            const payload = JSON.parse(atob(token.split('.')[1]))

            const exp = payload.exp * 1000
            const refreshAt = exp - 30_000 // refresh 30 sec before expiry

            const delay = refreshAt - Date.now()

            if (delay <= 0) {
                store.dispatch('authModule/refreshAccessToken')
                return
            }
            // Clear previous timer
            if (window.__refreshTimer) clearTimeout(window.__refreshTimer)
            window.__refreshTimer = setTimeout(() => {
                store.dispatch('authModule/refreshAccessToken')
            }, delay)
        }
    )
}

setupAccessTokenWatcher(store)
